import { inject } from 'mobx-react'
import type { Location } from 'react-router-dom'
import * as React from 'react'
import routes, { navigationSections } from '../../Routes'
import { Router } from '../../routing'
import { IStores } from '../../Stores'
import NavigationDrawer from '../NavigationDrawer'
import NavigationSync from '../NavigationSync'

interface IContainerProps {
  children: React.ReactNode
  className: string
  isLoggedIn: boolean
  drawerWidth: number
  isOnLogin: boolean
}

const container: React.FC<IContainerProps> = (props) => (
  <div
    className={props.className}
    style={{
      height: '100%',
      marginLeft: `${props.isLoggedIn && !props.isOnLogin ? props.drawerWidth : 0}px`,
    }}
  >
    {props.children}
  </div>
)

interface IShellProps {
  drawerWidth?: number
  isDrawerOpen?: boolean
  isTooltipOpen?: boolean
  isLoggedIn?: boolean
  location?: Location
  rerouteIfNotLoggedIn?: (location?: Location) => void
  toggleDrawer?: () => void
}

class Shell extends React.Component<IShellProps> {
  public componentDidMount() {
    this.props.rerouteIfNotLoggedIn!()
  }

  public componentDidUpdate(prevProps: IShellProps) {
    // Check if location changed and call rerouteIfNotLoggedIn
    if (this.props.location !== prevProps.location) {
      this.props.rerouteIfNotLoggedIn!(this.props.location)
    }
  }

  public render() {
    const {
      drawerWidth,
      isDrawerOpen,
      isTooltipOpen,
      isLoggedIn,
      location,
      toggleDrawer,
    } = this.props
    const isOnLogin =
      !location ||
      location.pathname === '/login' ||
      location.pathname === '/magic-link' ||
      location.pathname === '/login/magic-link'

    return (
      <Router
        container={container}
        containerProps={{ drawerWidth, isLoggedIn, isOnLogin }}
        routes={routes}
      >
        <NavigationSync />
        {isLoggedIn && !isOnLogin && (
          <NavigationDrawer
            isOpen={isDrawerOpen!}
            isTooltipOpen={isTooltipOpen!}
            toggleDrawer={toggleDrawer!}
            navigationSections={navigationSections}
          />
        )}
      </Router>
    )
  }
}

const InjectedShell = inject<IStores, IShellProps, Partial<IShellProps>, any>(
  (stores: IStores) => ({
    drawerWidth: stores.global.drawerWidth,
    isDrawerOpen: stores.global.isDrawerOpen,
    isLoggedIn: stores.global.isLoggedIn,
    location: stores.routing?.location ?? undefined,
    rerouteIfNotLoggedIn: stores.global.rerouteIfNotLoggedIn,
    toggleDrawer: stores.global.toggleDrawer,
  })
)(Shell)

export default InjectedShell
